import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {resolveApiBase} from '../../core/api-base';

export interface PendingTerm {
  id: string;
  kind: 'term' | 'permission';
  number: string;
  version: number;
  resume: string;
  fullText: string;
}

// Wire keys are snake_case: consent's acceptanceRequest decodes client_id
// (backend/consent/internal/enduser/main.go), the same name the GET
// /terms/pending query uses. camelCase here decoded to "" and every submit
// 401'd from authenticate() — broken from Epic 38 until 2026-10-05. Story 53.9:
// no session field at all — the session is the host-only cookie the browser
// attaches; one transport, so no field names left to drift.
export interface TermsAcceptanceRequest {
  client_id: string;
  decisions: {termId: string; decision: string}[];
}

export interface TermsAcceptanceResponse {
  result: 'accepted' | 'denied';
}

@Injectable({
  providedIn: 'root'
})
export class TermsAcceptanceService {
  private readonly http = inject(HttpClient);

  getPendingTerms(clientId: string): Observable<PendingTerm[]> {
    return this.http.get<PendingTerm[]>(
      `${resolveApiBase()}/terms/pending`,
      {params: {client_id: clientId}}
    );
  }

  postAcceptance(body: TermsAcceptanceRequest): Observable<TermsAcceptanceResponse> {
    return this.http.post<TermsAcceptanceResponse>(
      `${resolveApiBase()}/terms/acceptance`,
      body
    );
  }
}
